import {
    ButtonPrimary,
    DataCard,
    IconSupportAgentRegular,
    Row,
    RowList,
    Text1,
    Text3,
    skinVars,
} from '@telefonica/mistica';
import React from 'react';
import './index.scss';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import navigateParams from '../../../utils/navigation/navigateParams';

const LoginHelp: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const sendToNative = (url: string, title: string) => {
        const type = 'fiber-test-speed';
        const queryParams = {};
        const storage = {};
        if (navigateParams(type, url, queryParams, storage, title)) {
            navigate(url);
        }
    };

    return (
        <div className='login-page'>
            <div className='login-page__title'>
                <Text3 regular>{t('contentModalHelpWithAccessTitle')}</Text3>
            </div>
            <div className='login-page__loginInformation'>
                <Text1 medium color={skinVars.colors.textSecondary}>
                    {t('contentModalLoginInformation')}
                </Text1>
            </div>
            <div className='login-page__rowLoginInformation'>
                <RowList>
                    <Row
                        title={t('contentModalLoginInformationRowOne')}
                        onPress={() => sendToNative('/login/help-with-access/sign-up', t('titleModalToSignUp'))}
                    ></Row>
                    <Row
                        title={t('contentModalLoginInformationRowTwo')}
                        onPress={() => sendToNative('/login/help-with-access/sign-up', t('titleModalToAccess'))}
                    ></Row>
                </RowList>
            </div>
            <div className='login-page__cardContact'>
                <DataCard
                    icon={<IconSupportAgentRegular size={24} />}
                    title={t('contentModalHelpWithAccessTitleCard')}
                    subtitle={t('contentModalHelpWithAccessSubtitleCard')}
                    button={
                        <ButtonPrimary small onPress={() => {}}>
                            {t('contentModalHelpWithAccessBtnCard')}
                        </ButtonPrimary>
                    }
                ></DataCard>
            </div>
        </div>
    );
};

export default LoginHelp;
